(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('RelationshipType', RelationshipType);

    RelationshipType.$inject = ['$resource'];

    function RelationshipType ($resource) {
        var resourceUrl =  'api/relationship-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
